import React from "react";
import MobileDrawer from "./MobileDrawer/MobileDrawer";
import NavBar from "./NavBar/NavBar";
import Footer from "./Footer/Footer";

export default function Layout({ children }) {
  return (
    <>
      <NavBar />
      <MobileDrawer />
      <div className="overflow">{children}</div>
      <Footer />
    </>
  );
}
